import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";
import MDBox from "components/MDBox";
import DefaultInfoCard from "components/Cards/InfoCards/DefaultInfoCard";
import MDTypography from "components/MDTypography";

const PartnerSummaryStatistics = ({ companionAnalyticsData, adminDashboardData }) => {
  const operationsList = [
    {
      id: "newRequests",
      color: "success",
      title: "New Requests",
      count: companionAnalyticsData?.receivedRequests, // recieved & pending (jobs)- pending (orders)
      icon: "add_circle_outline",
    },
    {
      id: "alerts",
      color: "error",
      title: "Pending Requests",
      count: companionAnalyticsData?.inprogressRequests, // aasigned & initialized (jobs)
      icon: "error_outline",
    },
    {
      id: "openRequests",
      color: "info",
      title: "Closed Requests",
      count: companionAnalyticsData?.closedRequests, // closed & delivered (jobs) - succeeded & closed & delivered (orders)
      icon: "check_circle_outline",
    },
    {
      id: "totalRequests",
      color: "primary",
      title: "Total Requests",
      count: companionAnalyticsData?.requestCreated,
      icon: "task",
    },
    {
      id: "avgRequestsPerGuest",
      color: "dark",
      title: "Avg. Requests Per Guest",
      count: companionAnalyticsData?.averageRequestPerGuest,
      icon: "legend_toggle",
    },
  ];

  const performanceList = [
    {
      id: "visits",
      color: "success",
      title: "Visits",
      count: companionAnalyticsData?.totalViews,
      icon: "login",
    },
    {
      id: "reservations",
      color: "info",
      title: "Rest. Reservations",
      count: adminDashboardData?.monthlyBooking?.totalBookingsCount,
      icon: "restaurant",
    },
    {
      id: "ticketsSold",
      color: "error",
      title: "Ticket Sold",
      count: adminDashboardData?.dailySales?.totalSalesCount,
      icon: "confirmation_number",
    },
    ...(companionAnalyticsData?.ignore
      ? []
      : [
          {
            id: "upsells",
            color: "warning",
            title: "Upsells",
            count: companionAnalyticsData?.upsells,
            icon: "north_east",
          },
        ]),
  ];

  return (
    <MDBox mt={1.5}>
      {!companionAnalyticsData?.ignore && (
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize" mb={2}>
          Operations
        </MDTypography>
      )}
      {!companionAnalyticsData?.ignore && (
        <Grid container spacing={3}>
          {operationsList.map((stat) => (
            <Grid size={{ xs: 12, md: 6, lg: 4 }} key={stat.id}>
              <MDBox mb={1.5}>
                <DefaultInfoCard
                  icon={stat.icon}
                  title={stat.title}
                  value={stat.count || 0}
                  color={stat.color}
                />
              </MDBox>
            </Grid>
          ))}
        </Grid>
      )}

      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize" mb={2}>
        Performance
      </MDTypography>
      <Grid container spacing={3}>
        {performanceList.map((stat) => (
          <Grid size={{ xs: 12, md: 6, lg: 4 }} key={stat.id}>
            <MDBox mb={1.5}>
              <DefaultInfoCard
                icon={stat.icon}
                title={stat.title}
                value={stat.count || 0}
                color={stat.color}
              />
            </MDBox>
          </Grid>
        ))}
      </Grid>
    </MDBox>
  );
};

PartnerSummaryStatistics.propTypes = {
  companionAnalyticsData: PropTypes.instanceOf(Object).isRequired,
  adminDashboardData: PropTypes.instanceOf(Object).isRequired,
};

export default React.memo(PartnerSummaryStatistics);
